// imports for app window layout
import { useAuth0 } from '@auth0/auth0-react';
import MainWindow from '../app_layout/main_window/MainWindow';
import ChatWindow from '../app_layout/chat_window/ChatWindow';
import SideBarInactive from '../app_layout/sidebar/SideBarInactive';
import APP_WINDOW_CONFIG from '../app_layout/layout_config';

// imports relevant for HTTP calls
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// import user session information
import UserSessionContext from '../user_session/context_user_session';

// imports this module specific
import ProjectInformation from './ProjectInformation';
import TeamTable from './TeamTable';
import YesNoPopup from '../popup_windows/YesNoPopup';
import '../css_styles/button_styles.css'
import { SetSessionInfo_OnMarkCurrentProject } from '../user_session/session_info_utils';
import InfoPopup from '../popup_windows/InfoPopup';

import { useNavigate } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';


function CreateNewProject() {


// ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // This Component requires to fetches data on first load -> setIsloading(true); 
    const [isLoading, setIsLoading] = useState(true);

// ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const { user } = useAuth0();

// ------------------ General Window Layout -----------------------------------------
    
    const [canvasSize, setCanvasSize] = useState({width: 0, height: 0});
    const [layout, setLayout] = useState({sidebar:0, main: 0, chat: 0});

    useEffect(() => {
        function handleResize() {
            let window_height = window.innerHeight;
            let window_width = window.innerWidth;
            let canvas_height = window_height - APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX;
            let sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_PX;
            let chat = (window_width - sidebar)*APP_WINDOW_CONFIG.CHAT_WIDTH_RELATIVE;
            chat = Math.max (chat, APP_WINDOW_CONFIG.MIN_CHAT_WIDTH_PX);
            let main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setCanvasSize({width: window_width, height: canvas_height});
            // if currently the sidebar is not toggled, then resize the sidbar widow to toggle_size
            sidebar = APP_WINDOW_CONFIG.SIDEBAR_WIDTH_COLLAPSED_PX;
            main = window_width - sidebar - chat - APP_WINDOW_CONFIG.OFFSET_WINDOW_RIGHT_PX;
            setLayout({sidebar:sidebar, main: main, chat: chat});
        }
        // Set initial height
        handleResize();
        // Add event listener to handle window resize
        window.addEventListener('resize', handleResize);
        // Remove event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Empty dependency array ensures the effect only runs once



// ------------------ Side Bar Content -----------------------------

const sidebar = (<>
                    <SideBarInactive width={layout.sidebar} />
                </>)


// ------------------ Main Window Content ----------------------------

    const [prjHeader, setProjHeader] = useState(null);
    const [templateTeamMember, setTemplateTeamMember] = useState(null);
    const [allTeamMembers, setAllTeamMembers] = useState([]);
    const [uuidNewProject, setUuidNewProject] = useState('')
    const [markCurrentPopup, setMarkCurrentPopup] = useState(false);
    const [msgPopupUpdatedBy, setMsgPopupUpdatedBy] = useState('')
    const [popupUpdatedBy, setPopupUpdatedBy] = useState(false);
    const navigate = useNavigate();

    // Fetch Template Objects for Project Header and Project Team

    useEffect(() => {
        setIsLoading(true); // Set loading state to true when fetch begins
        const fetchData1 = fetch(`${SERVER_URL}/new_project/header_template/`, {
            method: 'GET',
        })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        const fetchData2 = fetch(`${SERVER_URL}/new_project/team_member_template/`, {
            method: "GET",
        })
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        Promise.all([fetchData1, fetchData2])
        .then(([fetchData1, fetchData2]) => {
            setProjHeader(fetchData1.data);
            // add 'selected' as key to the list of team members -> this enables to select the team member in the InteractiveTable
            // set 'selected'=false as default, aka team member is not selected by default
            // set 'selected' is expected the first key in the dictionary
            let team_row = {selected: false};
            // Copy existing key-value pairs to the new object
            for (let key in fetchData2.data) {
                if (fetchData2.data.hasOwnProperty(key)) {
                    team_row[key] = fetchData2.data[key];
                }
            }   
            setTemplateTeamMember(team_row);
            setIsLoading(false);
        })
        .catch((err) => {
            setException(true)
            setExceptionMessage(`HTTPException: err_msg=${err.message}`)
        });
    }, []);


    // Define Relevant Handers To Collect Various User Inputs
    // * Handle Project Title Input
    // * Handle Description Input 
    // * Handle Create New Team Members
    // * Handle Remove Team Members
    // * Handle Team Input
    // * Handle Create Project
    // * Handle Mark New Project as Current: IF Yes
    // * Handle Mark New Project as Current: IF No

    function handleTitle(event) {
        event.preventDefault();
        let key = event.target.id;
        let value = event.target.value;
        setProjHeader(prevData => ({...prevData, [key]: value }));
    }

    function handleQillDescription(html) {
        let key = 'description'
        setProjHeader(prevData => ({...prevData, [key]: html }));
    }


    function handleNewTeamMember(event){
        setAllTeamMembers(prevTeam => [...prevTeam, templateTeamMember]);
    }

   function handleRemoveTeamMember(){
        const updatedTeam = allTeamMembers.filter((member) => !member.selected);
        setAllTeamMembers(updatedTeam)
   }

   function handleTeamInput(event)
    {
        let key_id = event.target.id.split('_');
        let key = key_id[0];
        let id = key_id[1];
        let value = event.target.value
        // for input checkbox, need to get property target.checked
        if (key === 'selected') 
        {
            value = event.target.checked;
        }
        let updatedTeam = [...allTeamMembers];
        updatedTeam[id] = { ...updatedTeam[id], [key]:value}; 
        setAllTeamMembers(updatedTeam)
    }

    function handleCreateProject(event){
        event.preventDefault()
        setIsLoading(true); 
        // remove the 'checked' key from allTeamMembers
        // This will create a deep copy of the data in allTeamMembers, aka stripping ['selected'] will not affect the original object 
        let team_members = JSON.parse(JSON.stringify(allTeamMembers));
        team_members.forEach(dict => {
                delete dict['selected'];
        });
        let new_project = {header: prjHeader,
                           team: team_members }
        // console.log(new_project)
        fetch(`${SERVER_URL}/new_project/create/`, {method: 'POST',
                                                            headers:{'Content-Type':'application/json',
                                                                     'auth0_user': user.sub,
                                                                     'uuid_tenant': usr_session_ctx.uuid_tenant }, 
                                                            body:JSON.stringify(new_project)})
        .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
            return res.json();
        })
        .then((data) => {
            setUuidNewProject(data.data)
            setIsLoading(false); 
        })
        .catch((err) => {
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        });

        setMarkCurrentPopup(true);
    }

   ///  DEFINE HANDLING EVENTS
   function handleMarkCurrentYes(event){

        let cannot_mark_current = false;
        if (usr_session_ctx.session_info.on_update_campaign.uuid_experimental_setup !== ''){
            cannot_mark_current = true
            setPopupUpdatedBy(true);
            setMsgPopupUpdatedBy(<>The active campaign setup is currently beeing updated. 
                                    Please finish your changes before loading another project.
                                    Your created project is now availalbe in All Projects.</>);
        }
        if (usr_session_ctx.session_info.on_create_campaign.uuid_experimental_setup !== ''){
            cannot_mark_current = true
            setPopupUpdatedBy(true);
            setMsgPopupUpdatedBy(<>An unfinished campaign has been detected in the Campaign Builder. 
                                Please complete your campaign setup before loading another project.
                                Your created project is now availalbe in All Projects.</>);
        }
        if (cannot_mark_current === false){
            // update UserSession -> update field 'uuid_current_project';

            usr_session_ctx.session_info = SetSessionInfo_OnMarkCurrentProject(usr_session_ctx, uuidNewProject)
            let session_update = {key: 'session_info', value: usr_session_ctx.session_info}

            fetch(`${SERVER_URL}/user_session/update_field/`, {method: 'PUT',
                headers:{'Content-Type':'application/json',
                        'auth0_user': user.sub,
                        'uuid_tenant': usr_session_ctx.uuid_tenant } ,
                body:JSON.stringify(session_update)
            })
            .then((res) => {
            if(!res.ok) {
                throw new Error(`HTTP error ${res.status}`);
            }
                return res.json();
            })
            .then((data) => {
                setIsLoading(false);
                setMarkCurrentPopup(false) 
                document.getElementById('nav_bar_current_project').click();
                navigate('/');
            })
                .catch((err) => {
                setException(true);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }
    }

    function handleMarkCurrentNo(event){
        // activate navigation button 'Current Project'
        document.getElementById('nav_bar_all_projects').click();
        setMarkCurrentPopup(false)
    }


    // Layout the inputs in the UI
    let mainWindow = (<></>);

    // actions = {}
    // Exection and Error Messeges Get Priority and Are Evaluated Before Anything els
    if(Exception){
        mainWindow = (<>
                <MainWindow width={layout.main} >
                    <DisplayException>
                        {ExceptionMessage}
                    </DisplayException>  
                </MainWindow>
            </>);
    }

    if (!isLoading && !Exception) {    
        if(!markCurrentPopup && !popupUpdatedBy){
            mainWindow = (<>
            <MainWindow width={layout.main} >
                <ProjectInformation projectInfo={prjHeader} handleDescription={handleQillDescription} handleTitle={handleTitle} />
                <h4 style = {{'margin':'0', 'marginBottom':'5px', 'marginTop':'30px', 'padding':'5px', position: 'relative', left:'3%', width:'94%'}} >Project Team</h4>
                <TeamTable onInput={handleTeamInput} 
                                  onAddRow={handleNewTeamMember}
                                  team={allTeamMembers}
                                  colNames={['', 'First Name', 'Last Name', 'Role', 'Department']} 
                                  actionPanel={[{title:'Remove', action:handleRemoveTeamMember}]}/>
                <div style={{position: 'relative', marginTop:'30px', marginBottom:'30px', left:'3%', width:'94%'}}>
                    <button className={'actionButton'} onClick={handleCreateProject}>Create Project</button>
                </div>
            </MainWindow>
        </>)
        }
        else if (markCurrentPopup && !popupUpdatedBy) {
            mainWindow = (<>
                <MainWindow width={layout.main} >
                    <YesNoPopup ypos={'60px'} handleYes={handleMarkCurrentYes} linkNo={'/all_projects'} handleNo={handleMarkCurrentNo} >
                        Success! <br/>
                        Mark the new project as current?
                    </YesNoPopup>
                </MainWindow>
            </>);
        }

        else if (popupUpdatedBy){
            mainWindow = (<>
                <MainWindow width={layout.main} >
                <div style={{position: 'relative', left:'3%', width:'94%', height:'100%'}}>
                    <InfoPopup ypos={'60px'} handleOk={()=>{setPopupUpdatedBy(false); 
                                                            setMsgPopupUpdatedBy('');
                                                            document.getElementById('nav_bar_all_projects').click();;
                                                            } } >
                        {msgPopupUpdatedBy}
                    </InfoPopup>
                    </div>
                </MainWindow>
                </>);
        }
   }
   if (isLoading && !Exception) {   
    mainWindow = (<>
            <MainWindow width={layout.main} >
                <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%', border:'1px solid black'}}>
                    <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                </div>
            </MainWindow>
        </>);
   }


// ------------------ Return All Components ----------------------------

    // Show Sidebar, MainWindow and ChatWindow
    return(
        <>
        <div style={{position:'relative', display:'grid', gridTemplateColumns: 'auto auto auto', overflow: 'hidden', left:`${APP_WINDOW_CONFIG.OFFSET_WINDOW_LEFT_PX}px`, top:`${APP_WINDOW_CONFIG.OFFSET_HEADER_YPOS_PX}px`, height:canvasSize.height, width:'100%'}}>
            {sidebar}
            {mainWindow}
            <ChatWindow width={layout.chat}/>
        </div>    
        </>
    );

}

export default CreateNewProject;